// Экран входа в пульт (задача D4), `/login?next=…`.
//
// Белая карточка 360 px на подложке: знак «✦ Анна» (Cuprum) и «ChinaToday» над заголовком, одна строка пояснения,
// почта, пароль, «Войти» во всю ширину (референсы Mobbin — docs/ui-spec.md, «Референсы»). После входа — на `next`,
// если это путь пульта, иначе — «Готовность».
import { useNavigate, useSearchParams } from 'react-router';
import { LoginForm } from './login-form';
import { safeNextPath } from './next-path';

export function LoginPage() {
  const [params] = useSearchParams();
  const navigate = useNavigate();

  return (
    <main className="flex min-h-dvh items-center justify-center bg-background p-4">
      <div className="w-full max-w-90 rounded-xl border border-border bg-card p-6 max-sm:p-5">
        <p className="mb-5 flex items-baseline gap-2">
          <span className="font-mark text-md font-bold">
            <span aria-hidden="true">✦</span> Анна
          </span>
          <span className="text-sm text-muted-foreground">ChinaToday</span>
        </p>
        <h1 className="text-xl font-semibold">Вход в пульт Анны</h1>
        <p className="mt-1 text-muted-foreground">Почта и пароль — те же, что в Омнидеске.</p>
        <LoginForm
          layout="page"
          focusOnMount
          className="mt-5"
          onSuccess={() => {
            void navigate(safeNextPath(params.get('next')), { replace: true });
          }}
        />
      </div>
    </main>
  );
}
